function updateCartLine(line, quantity) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
  })
    .then((res) => res.json())
    .then((cartData) => {
      // Update header cart count
      const headerCartCount = document.querySelector(".header__cart-count[data-cart-count]");
      if (headerCartCount && cartData.item_count !== undefined) {
        headerCartCount.textContent = cartData.item_count;
        headerCartCount.setAttribute("data-cart-count", cartData.item_count);
      }

      // Reload cart section via AJAX
      fetch(window.location.pathname + "?section_id=main-cart")
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newCart = doc.querySelector(".cart");
          const oldCart = document.querySelector(".cart");
          if (newCart && oldCart) {
            oldCart.replaceWith(newCart);
          } else {
            window.location.reload();
          }
        })
        .catch(() => window.location.reload());
    })
    .catch(() => window.location.reload());
}

function refreshCartPrices() {
  fetch("/cart.js", {
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => response.json())
    .then((data) => {
      // Update cart total
      document.querySelectorAll(".cart-order__total").forEach(function (element) {
        element.innerHTML = Shopify.formatMoney(data.total_price);
      });
      // Update per-item prices
      data.items.forEach((item) => {
        let itemWrapper = document.querySelector(`.cart-list__item[data-item-id="${item.id}"]`);
        if (itemWrapper) {
          let priceEl = itemWrapper.querySelector(".cart-list__price");
          if (priceEl) priceEl.innerHTML = Shopify.formatMoney(item.line_price);
        }
      });
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

document.body.addEventListener("change", function (e) {
  // Quantity input changes (from QuantitySelector buttons or direct input)
  if (e.target.matches('input[type="number"][data-item-key]') && e.target.closest(".quantity-selector")) {
    const input = e.target;
    const itemWrapper = input.closest(".cart-list__item");
    if (!itemWrapper) return;

    const line = itemWrapper.getAttribute("data-line");
    const quantity = parseInt(input.value, 10);

    if (quantity > 0) {
      updateCartLine(line, quantity);
    }
  }
});

document.body.addEventListener("click", function (e) {
  // Remove button
  if (e.target.closest(".cart-list__remove")) {
    const btn = e.target.closest(".cart-list__remove");
    const line = btn.getAttribute("data-line");
    updateCartLine(line, 0);
  }

  // Quantity selector buttons (plus/minus)
  if (e.target.closest(".quantity-selector__button")) {
    const button = e.target.closest(".quantity-selector__button");
    const quantitySelector = button.closest(".quantity-selector");
    const input = quantitySelector.querySelector('input[type="number"]');
    const itemWrapper = button.closest(".cart-list__item");

    if (!input || !itemWrapper) return;

    const line = itemWrapper.getAttribute("data-line");
    const currentQuantity = parseInt(input.value, 10);
    const step = parseInt(input.getAttribute("step") || "1", 10);
    const min = parseInt(input.getAttribute("min") || "1", 10);
    const max = input.getAttribute("max") ? parseInt(input.getAttribute("max"), 10) : null;

    let newQuantity = currentQuantity;

    // Check if it's the decrease button (minus icon)
    if (button.querySelector('[class*="minus"]') || button.getAttribute("aria-label").includes("decrease")) {
      newQuantity = Math.max(min, currentQuantity - step);
    }
    // Check if it's the increase button (plus icon)
    else if (button.querySelector('[class*="plus"]') || button.getAttribute("aria-label").includes("increase")) {
      newQuantity = max ? Math.min(max, currentQuantity + step) : currentQuantity + step;
    }

    if (newQuantity !== currentQuantity) {
      input.value = newQuantity;
      updateCartLine(line, newQuantity);
    }
  }
});

// Color Dropdown for Cart
(function () {
  function closeAllDropdowns() {
    document.querySelectorAll(".variant-select.open").forEach((sel) => sel.classList.remove("open"));
  }

  document.body.addEventListener("click", function (e) {
    const select = e.target.closest(".variant-select");
    // Allow clicking on .variant-select__selected or any child (like the icon)
    if (select && (e.target.matches("[data-selected]") || e.target.closest("[data-selected]"))) {
      if (select.classList.contains("open")) {
        select.classList.remove("open");
      } else {
        closeAllDropdowns();
        select.classList.add("open");
      }
      e.stopPropagation();
      return;
    }
    if (select && e.target.matches(".variant-select__option")) {
      const option = e.target;
      const newColor = option.getAttribute("data-value");
      const newVariantId = option.getAttribute("data-variant-id");
      const itemKey = select.getAttribute("data-item-key");
      // Get current quantity from input in the same cart item
      const cartItem = select.closest(".cart-list__item");
      let currentQuantity = 1;
      if (cartItem) {
        const qtyInput = cartItem.querySelector('input[name="quantity"]');
        if (qtyInput && qtyInput.value) {
          currentQuantity = Number(qtyInput.value);
        } else if (cartItem.dataset.quantity) {
          currentQuantity = Number(cartItem.dataset.quantity);
        }
      }

      if (option.classList.contains("selected")) {
        select.classList.remove("open");
        return;
      }
      // Remove current item
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      })
        .then(() => {
          // Add new variant with same quantity
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              id: Number(newVariantId),
              quantity: Number(currentQuantity),
            }),
          });
        })
        .then(() => {
          // Reload cart section via AJAX
          fetch(window.location.pathname + "?section_id=main-cart")
            .then((r) => r.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newCart = doc.querySelector(".cart");
              const oldCart = document.querySelector(".cart");
              if (newCart && oldCart) {
                oldCart.replaceWith(newCart);
              } else {
                window.location.reload();
              }
            })
            .catch(() => window.location.reload());
        })
        .catch(() => window.location.reload());
      select.querySelectorAll(".variant-select__option").forEach((opt) => opt.classList.remove("selected"));
      option.classList.add("selected");
      select.querySelector("[data-selected]").textContent = newColor;
      select.classList.remove("open");
      e.stopPropagation();
      return;
    }
    if (!e.target.closest(".variant-select")) {
      closeAllDropdowns();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAllDropdowns();
  });
})();
